<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">员工</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>kpi列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
        <history></history>
        <!-- <el-input placeholder="请输入员工id" clearable v-model="params.userId">
      </el-input> -->
        <!-- <el-button @click="handleSearch" type="primary">查询员工历史KPI</el-button> -->
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import Create from './components/create';
import History from './components/history';

export default {
  name: 'kpiList',
  data() {
    return {
      params: {
        userId: ''
      }
    };
  },
  components: {
    List,
    Create,
    History
  },
  computed: {
    ...mapState('kpi', ['pagination'])
  },
  methods: {
    ...mapActions('kpi', ['getRecords']),
    handleSearch() {
      this.getList();
    },
    getList(data = {}) {
      this.getRecords({
        ...this.params,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
